import { useEffect } from "react";

import {
  connectWoTechStatusSocket,
  disconnectWoTechStatusSocket,
} from "src/Services/socket/woTechStatusSocket";

// Team-wide variant of useWoTechStatusRealtime: joins the shared team room so
// every tech-status change is received, regardless of which WO it belongs to.
// Used by the Team > Status board to stay live without polling.
const useTeamTechStatusRealtime = ({ enabled = true, onTechStatusChanged }) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const socket = connectWoTechStatusSocket();

    const joinRoom = () => {
      socket.emit("wo-tech-status:team:join");
    };

    const handleTechStatusChanged = (payload) => {
      onTechStatusChanged?.(payload);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }
      connectWoTechStatusSocket();
      joinRoom();
    };

    socket.on("connect", joinRoom);
    socket.on("wo-tech-status-changed", handleTechStatusChanged);

    if (socket.connected) {
      joinRoom();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      socket.off("connect", joinRoom);
      socket.off("wo-tech-status-changed", handleTechStatusChanged);
      socket.emit("wo-tech-status:team:leave");
      disconnectWoTechStatusSocket();
    };
  }, [enabled, onTechStatusChanged]);
};

export default useTeamTechStatusRealtime;
